import React, { Children } from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  emoji: '🚀',
  title: 'Confianza',
  desc: 'Sentirse capaz de intentar cosas nuevas.',
  color: 'border-blue-400/50'
}, {
  emoji: '🧘',
  title: 'Autocontrol',
  desc: 'Herramientas simples para calmar el cuerpo y la mente.',
  color: 'border-green-400/50'
}, {
  emoji: '💖',
  title: 'Amor Propio',
  desc: 'Reconocer que su valor no depende de lo que hace, sino de quién es.',
  color: 'border-softPink/50'
}, {
  emoji: '🌟',
  title: 'Conexión Familiar',
  desc: 'Un ritual de paz antes de dormir o al empezar el día.',
  color: 'border-gold/50'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function BenefitsSection() {
  return <section className="relative z-10 px-6 py-16 md:py-24" data-id="element-11">
      <div className="max-w-4xl mx-auto" data-id="element-12">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center text-white font-heading mb-12" data-id="element-13">
          Beneficios Reales
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-14">
          {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className={`glass-card p-6 border-l-4 ${benefit.color} hover:bg-white/10 transition-colors duration-300`} data-id="element-15">
              <div className="text-4xl mb-4" data-id="element-16">{benefit.emoji}</div>
              <h3 className="text-xl font-bold text-white font-heading mb-2" data-id="element-17">
                {benefit.title}
              </h3>
              <p className="text-warmWhite font-body" data-id="element-18">{benefit.desc}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}